import React from 'react';
export function Page31FAQHeader() {
  return <h2 className="text-4xl md:text-5xl text-ink text-center mb-12" data-id="element-2748">
      Frequently Asked Questions
    </h2>;
}